import { createFileRoute } from "@tanstack/react-router"
import { ApiUsageDashboard } from "@/features/api-usage/ApiUsageDashboard"
import {
	type UsageSearch,
	validateUsageSearch,
} from "@/features/api-usage/filters"

export const Route = createFileRoute("/api-usage/")({
	component: ApiUsagePage,
	validateSearch: validateUsageSearch,
})

function ApiUsagePage() {
	const search = Route.useSearch()
	const navigate = Route.useNavigate()

	const onChange = (patch: Partial<UsageSearch>) => {
		navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })
	}

	return <ApiUsageDashboard search={search} onChange={onChange} />
}
